export enum OrientationType {
  Front = "front",
  Back = "back",
  // Left = "left",
  // Right = "right",
  Label = "label",
}
